import style from "./index.module.css";
import EducationDropDown from "components/EducationDropDown";

const Education = () => {
  let data = [
    {
      titile: "HR менеджер по международным стандартам.",
      body: [
        {
          text: "Обзор HRM платформы PeopleForce - лучший функционал и лучший дизайн 🔥HRM прожарка🔥",
          text: "Обзор HRM платформы PeopleForce - лучший функционал и лучший дизайн 🔥HRM прожарка🔥",
        },
      ],
    },
    {
      titile: "HR менеджер по международным стандартам.",
      body: "Обзор HRM платформы PeopleForce - лучший функционал и лучший дизайн 🔥HRM прожарка🔥",
    },
  ];
  return (
    <div className={style.wrapper}>
      <div className={style.section_head}>
        <p className={style.title}>Обучение</p>
      </div>

      <div className={style.tabel_wrapper}>
        <div className={style.accordions}>
          <div className={style.box}>
            <EducationDropDown data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
